// extracted by mini-css-extract-plugin
export const headline = "register-module--headline--2Cvv3";
export const form = "register-module--form--13qIk";
export const row = "register-module--row--3NHAY";
export const footer = "register-module--footer--16lfA";